export var selectSelectedIds = function selectSelectedIds(state) {
  return state.favoritesAssignWidget.selected;
};